const LEAGUES = [
  {
    id: "nfl",
    name: "NFL",
    league_friendly_name: "NFL",
    icon: "Leagues/NFL/NFL.png",
    sport: "football",
  },
  {
    id: "epl",
    name: "EPL",
    league_friendly_name: "Premier League",
    icon: "Leagues/EPL/EPL.png",
    sport: "soccer",
  },
  {
    id: "big10",
    name: "BIG10",
    league_friendly_name: "Big Ten",
    icon: "Leagues/BIG10/BIG10.png",
    sport: "college",
  },
  {
    id: "nba",
    name: "NBA",
    league_friendly_name: "NBA",
    icon: "Leagues/NBA/NBA.png",
    sport: "basketball",
  },
  {
    id: "wnba",
    name: "WNBA",
    league_friendly_name: "WNBA",
    icon: "Leagues/WNBA/WNBA.png",
    sport: "basketball",
  },
  {
    id: "mlb",
    name: "MLB",
    league_friendly_name: "MLB",
    icon: "Leagues/MLB/MLBDark.png",
    sport: "baseball",
  },
  // { id: "League_MLS", name: "MLS", icon: "Leagues/MLS/MLS.png" },
  // {
  //   id: "League_USATF",
  //   name: "USATF",
  //   league_friendly_name: "US Track & Field",
  //   icon: "Leagues/USATF/USATF.png",
  // },
];

export default LEAGUES;
